export const _prcpcoPayTitle1 = '高原茶油-山茶油产品'
export const _prcpcoPayTitle2 = '高原茶油...'
export const _prcpcoRechargeTitle = '高原茶油-充值'

export const _prcpcoFreeShipping = 1500 // 高原茶油免运费金额

// 屏幕 宽度 540
export const _SM_540 = 540

// 后台做 XSRF 校验的Token
export const _XSRF = 'bZJc2sWbQLKos6GkHn/VB9oLkzt8S0R0kRvJ5/xJ89E='

export const _NOTIFY_MAIN_TABBAR_SHOW = 'Notify_Main_TabBar_Show'
export const _NOTIFY_RECHARGE_BOTTOM_TABBAR_SHOW = 'Notify_Recharge_Bottom_TabBar_Show'
export const _NOTIFY_SHOPPING_BOTTOM_TABBAR_SHOW = 'Notify_Shopping_Bottom_TabBar_Show'
export const _NOTIFY_GOODSDETAILS_BOTTOM_TABBAR_SHOW = 'Notify_GoodsDetails_Bottom_TabBar_Show'
export const _NOTIFY_MY_BOTTOM_TABBAR_SHOW = 'Notify_My_Bottom_TabBar_Show'
export const _NOTIFY_SHOPPING_ORDER_SUCCESS = 'Notify_Shopping_Order_Success'
export const _NOTIFY_SHOW_ADD_CART_BTN = 'Notify_Show_Add_Cart_Btn'

export const _OPEN_RECHARGE_UPWINDOWS = 'Open_Recharge_UpWindows'
export const _OPEN_SHOPPING_UPWINDOWS = 'Open_Shopping_UpWindows'
export const _OPEN_DETAILS_UPWINDOWS = 'Open_Details_UpWindows'
export const _OPEN_CANCEL_ORDER_UPWINDOWS = 'Open_Cancel_Order_UpWindows'
export const _OPEN_GO_PAY_UPWINDOWS = 'Open_Go_Pay_UpWindows'
export const _OPEN_CONFIRM_RECEIPT_ORDER_UPWINDOWS = 'Open_Confirm_Receipt_Order_UpWindows'

export const _QUERY_USER_RECHARGE__INFO = 'QueryUserRechargeInfo'

// T提示电话号码输入有错，重新输入
export const _TIP_PHONEFILTER_WONG = 'TipPhoneFilterWong'

// 返回微信支付时统一下单接口使用的产品称谓
export function GetPayTitle (aType) {
  if (aType === 1) {
    return _prcpcoPayTitle1
  } else if (aType === 2) {
    return _prcpcoPayTitle2
  } else if (aType === 3) {
    return _prcpcoRechargeTitle
  }
}
// 返回免运费的购物金额
export function GetFreeShipping () {
  return _prcpcoFreeShipping
}

// 计算运费
export function ComputeFreight (TotalWeight) {
  let aTotalWeight = TotalWeight
  // 高原茶油运费计算方法
  if (TotalWeight <= 1) { // 首重为1公斤
    return 18
  } else { // 超过1公斤每公斤6元
    aTotalWeight = TotalWeight - 1
    aTotalWeight = Math.ceil(aTotalWeight)
    aTotalWeight = 18 + aTotalWeight * 6
    return aTotalWeight
  }
}

// 返回免运费提示
export function GetFreeShippingTxt () {
  if (_prcpcoFreeShipping === 0) {
    return '包邮'
  } else {
    return '订单满' + _prcpcoFreeShipping.toString() + '元免运费'
  }
}

export function uuid2 (len, radix) {
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  var uuid = []
  var i
  radix = radix || chars.length

  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    var r

    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'

    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }

  return uuid.join('')
}



// WEBPACK FOOTER //
// ./src/shared/global.js